const Home = () => import('../pages/home').then(m => m.default || m)
const Trck = () => import('../pages/trck').then(m => m.default || m)
const processCallback = () => import('../pages/processCallback').then(m => m.default || m)

const Login = () => import('../pages/auth/login').then(m => m.default || m)
const PasswordReset = () => import('../pages/auth/password/reset').then(m => m.default || m)
const PasswordRequest = () => import('../pages/auth/password/email').then(m => m.default || m)

const Settings = () => import('../pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('../pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('../pages/settings/password').then(m => m.default || m)
const SettingsSubscriptions = () => import('../pages/settings/subscriptions').then(m => m.default || m)
const SettingsFavourites = () => import('../pages/settings/favourites').then(m => m.default || m)

const AlertsIndex = () => import('../pages/alerts/index').then(m => m.default || m)
const AlertsShow = () => import('../pages/alerts/show').then(m => m.default || m)

const ArticlesIndex = () => import('../pages/articles/index').then(m => m.default || m)
const ArticlesShow = () => import('../pages/articles/show').then(m => m.default || m)

const TEC = () => import('../pages/tec/index').then(m => m.default || m)
const ContactUs = () => import('../pages/contact/index').then(m => m.default || m)
const DiscontinuedIndex = () => import('../pages/discontinued/index').then(m => m.default || m)


export default [
    {path: '/', name: 'home', component: Home},
    {path: '/trck', name: 'trck', component: Trck},
    {path: '/subscription/process/:guard/:redirect', name: 'processCallback', component: processCallback},
    {path: '/subscription/process/:guard', name: 'processCallback', component: processCallback},

    {path: '/login', name: 'login', component: Login},
    {path: '/password/reset', name: 'password.request', component: PasswordRequest},
    {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},

    {
        path: '/settings', component: Settings, children: [
            {path: '', redirect: {name: 'settings.profile'}},
            {path: 'password', name: 'settings.password', component: SettingsPassword},
        ]
    },

    {path: '/profile', name: 'profile', component: SettingsProfile},
    {path: '/subscriptions', name: 'subscriptions', component: SettingsSubscriptions},
    {path: '/favourites', name: 'favourites', component: SettingsFavourites},

    {path: '/alertas/', name: 'alerts.index', component: AlertsIndex},
    {path: '/alertas/:slug', name: 'alerts.show', component: AlertsShow},

    {path: '/noticias/', name: 'article.index', component: ArticlesIndex},
    {path: '/noticias/:slug', name: 'article.source', component: ArticlesIndex},
    {path: '/noticias/search/:query', name: 'article.search', component: ArticlesIndex},
    {path: '/noticia/:slug', name: 'article.show', component: ArticlesShow},

    {path: '/pages/tec', name: 'tec', component: TEC},
    {path: '/pages/contact', name: 'contact-us', component: ContactUs},

    {path: '*', name: '404', component: require('../pages/errors/404.vue')},

    { path: '/discontinued', name: 'Discontinued', component: DiscontinuedIndex }

]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js